import { render, staticRenderFns } from "./VersionsDialog.vue?vue&type=template&id=00030362&scoped=true"
import script from "./VersionsDialog.vue?vue&type=script&lang=ts"
export * from "./VersionsDialog.vue?vue&type=script&lang=ts"
import style0 from "./VersionsDialog.vue?vue&type=style&index=0&id=00030362&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00030362",
  null
  
)

export default component.exports